export type ChartDataItem = { d: string; v: number }

const INTERVAL_MINUTES = 15
const POINTS_PER_DAY = (24 * 60) / INTERVAL_MINUTES
const TOTAL_DAYS = 2
const TOTAL_POINTS = TOTAL_DAYS * POINTS_PER_DAY

const formatDate = (date: Date): string => {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  const h = String(date.getHours()).padStart(2, '0')
  const min = String(date.getMinutes()).padStart(2, '0')
  const s = String(date.getSeconds()).padStart(2, '0')
  return `${y}-${m}-${d}T${h}:${min}:${s}`
}

const generateMockSeries = (
  start: Date,
  base: number,
  wave: (i: number) => number,
  noise: () => number
): ChartDataItem[] =>
  Array.from({ length: TOTAL_POINTS }, (_, i) => {
    const date = new Date(start.getTime() + i * INTERVAL_MINUTES * 60 * 1000)
    return {
      d: formatDate(date),
      v: Number((base + wave(i) + noise()).toFixed(2)),
    }
  })

const startDate = new Date(Date.UTC(2026, 2, 6, 0, 14, 50))

export const chart1MockData: ChartDataItem[] = generateMockSeries(
  startDate,
  13,
  (i) => Math.sin((i / 96) * Math.PI * 2) * 1.5,
  () => (Math.random() - 0.5) * 0.3
)

export const chart2MockData: ChartDataItem[] = generateMockSeries(
  startDate,
  50,
  (i) => Math.cos((i / 96) * Math.PI) * 40,
  () => (Math.random() - 0.5) * 5
)

export const toChartPoints = (
  items: ChartDataItem[]
): { x: number; y: number }[] =>
  items.map((item) => ({ x: Date.parse(item.d), y: item.v }))
